export default __webpack_public_path__ + "static/media/d-walker.ba5f654d.png";